module.exports = __webpack_public_path__ + "static/hecha_test.ca81d70d.mp4";